import { faChartPie, faFileAlt, faClipboardList } from '@fortawesome/free-solid-svg-icons'
import React, { useContext, useEffect, useState } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { Container, TabButton } from '../Library'
import { BrowserRouter, Route } from 'react-router-dom'
import './ListSpare.css'
import Dashboard from './Dashboard'
import { Switch } from 'react-router-dom'
import { setDocumentTitle } from '../AppTitle'
import { Button, Form } from 'react-bootstrap'
import { listCompany } from '../Network/Company'
import { NotifyContext } from '../Library/Notify'
import SpareMangeDevice from './SpareManageDevice'
import SpareMangeDeviceCreate from './SpareManageDeviceCreate'
import SpareMangeDeviceEdit from './SpareManageDeviceEdit'

function ListSpare() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.listspare

    const [companyList, setCompanylist] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [chooseCompany, setChooseCompany] = useState();
    const notifyCx = useContext(NotifyContext)

    const fetchList = () =>{
        setLoading(true)
        listCompany(
            (data)=>{
                setChooseCompany(data[0].id)
                setCompanylist(data)
                setLoading(false)
            }, 
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            }
        )
    }

    useEffect( async ()=>{
        setDocumentTitle("ListSpare")
        listCompany(
            (data)=>{
                setChooseCompany(data[0].id)
                setCompanylist(data)
                setLoading(false)
            },
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            }
        )
        console.log(chooseCompany)
        fetchList()
    },[])



    return (
        <Container topbarTitle={lang.list_spare}>
            <BrowserRouter basename='/listspare'>
                <div className='nav-container'>
                    <div className='nav-left'>
                        <TabButton title={lang.list_spare} icon={faClipboardList} to='/' exact={true}/>
                    </div>
                    <div className='nav-right'>
                            <Form.Control as="select" value={chooseCompany} onChange={(e)=>setChooseCompany(e.target.value)} style={{ marginRight:'10px' }}>
                                {
                                   companyList.map((item, key) =>
                                   <option value={item.id} key={key}>{item.name}</option>
                                   )
                                }
                            </Form.Control>
                            <TabButton title={lang.manage_device} icon={faFileAlt} to='/managedevice' />
                    </div>
                </div>
                <hr/>
                <Switch>
                    
                    <Route path="/" render={(props) => <Dashboard {...props} company={chooseCompany} />}  exact>
                    </Route>
                    <Route path="/managedevice" render={(props) => <SpareMangeDevice {...props} company={chooseCompany} />} exact>
                    </Route>
                    <Route path="/managedevice/create" render={(props) => <SpareMangeDeviceCreate {...props} company={chooseCompany}/>} >
                    </Route>
                    <Route path="/managedevice/edit/:partID" render={(props) => <SpareMangeDeviceEdit {...props} company={chooseCompany} />}>
                    </Route>
                    {/*
                    <Route path="/visitor_security" render={(props) => <VisitorSecurity {...props} company={chooseCompany} />} exact>
                    </Route>
                    
                    
                    */}
                </Switch>
            </BrowserRouter>
        </Container>
    )
}


export default ListSpare
